<template>
  <div class="template-connected">
    <div id="container">
      <div id="title">
        <h1 v-if="add">Dépôt demande</h1>
        <h1 v-else>Mise à jour demande</h1>
      </div>
      <div id="content" class="form-horizontal">
        <b-row>
          <b-col
            lg="12"
            md="12"
            sm="12"
            cols="12"
            :class="stepperClass"
            id="form"
          >
            <v-stepper ref="stepper" :steps="steps" v-model="stepControl">
              <template slot="step-1"> Localisation</template>
              <template slot="step-2"> Demande</template>
              <template slot="step-3"> Demandeur</template>
              <template slot="step-4"> Chantier</template>
              <template slot="step-5"> Pièces Jointes</template>
              <template slot="step-6"> Attestation</template>
            </v-stepper>
          </b-col>
        </b-row>
      </div>
      <div v-show="step === 1">
        <localisation
          v-if="render"
          :add="add"
          @error="error($event)"
          @previous="previousStep($refs.stepper)"
          @submit="nextStep($refs.stepper)"
        ></localisation>
      </div>
      <div v-show="step === 2">
        <info-demande
          :add="add"
          v-if="render"
          @error="error($event)"
          @previous="previousStep($refs.stepper)"
          @submit="nextStep($refs.stepper)"
        ></info-demande>
      </div>
      <div v-show="step === 3">
        <demandeur
          :add="add"
          v-if="render"
          @error="error($event)"
          @previous="previousStep($refs.stepper)"
          @submit="nextStep($refs.stepper)"
        ></demandeur>
      </div>
      <div v-show="step === 4">
        <choix-cerfa
          :add="add"
          v-if="render"
          @error="error($event)"
          @previous="previousStep($refs.stepper)"
          @submit="nextStep($refs.stepper)"
        ></choix-cerfa>
      </div>
      <div v-show="step === 5">
        <pieces
          @error="error($event)"
          @previous="previousStep($refs.stepper)"
          @submit="nextStep($refs.stepper)"
          v-model="pieces"
          v-if="render"
        ></pieces>
      </div>
      <div v-show="step === 6">
        <attestation
          :add="add"
          v-if="render"
          @error="error($event)"
          @previous="previousStep($refs.stepper)"
          @submit="nextStep($refs.stepper)"
        >
        </attestation>
      </div>
    </div>
  </div>
</template>

<script>
import { VStepper } from "vue-stepper-component";
import Vuex from "vuex";

import router from "../router/index.js";
import Localisation from "../views/Cerfas/Localisation.vue";
import Demandeur from "../views/Cerfas/Demandeur.vue";
import ChoixCerfa from "../views/Cerfas/ChoixCerfa.vue";
import Attestation from "./Cerfas/Attestation.vue";
import PiecesJointes from "./Cerfas/PiecesJointes.vue";
import InfoDemande from "../views/Cerfas/InfoDemande.vue";
import Vue from "vue";

export default {
  name: "AjoutDossier",

  async mounted() {
    this.setStep(1);
    let rep = null;
    if (this.$route.params.id) {
      this.add = false;
      rep = await this.getDossier(this.$route.params.id);
      rep = await this.setPetitioner(this.request.petitioner);

      if (this.request.beneficiary != null) {
        rep = await this.setBeneficiary(this.request.beneficiary);
        this.request.isbeneficiaire = true;
      }

      rep = await this.setCerfa14024(this.request.cerfa1402401);
      rep = await this.setCerfa14023(this.request.cerfa1402301);
    } else {
      this.add = true;
      rep = await this.initDossier();

      rep = await this.initPoint();
      rep = await this.initPetitioner(false);
      rep = await this.initPetitioner(true);

      rep = await this.initCerfa14024();
      rep = await this.initCerfa14023();
    }
    this.render = true;
  },

  beforeDestroy() {
    //vidage du niveau de dessin et de point
    window.Event.$emit("clearLayer", "RequestPointLayer");
    window.Event.$emit("clearLayer", "drawnFeatures");
  },
  data: () => ({
    add: true,
    stepperClass: "no-padding form-horizontal",
    render: false,
    pieces: {
      isValid: true,
      // file : null
      cerfa14023: {
        pieceComplementaire: null,
        planSituation: null,
        planLocalisation: null,
        photos: null,
        nature: {
          clotureStationnement: {
            coupesLongitudinales: null,
          },
          amenagement: {
            planOuvrage: null,
            coupesTechniques: null,
            planFranchissement: null,
          },
          stationService: {
            planImplantation: null,
          },
        },
      },
      cerfa14024: {
        pieceComplementaire: null,
        notice: null,
        planSituation: null,
        planTravaux: null,
        schemaSignalisation: null,
        itineraireDeviation: null,
      },
      types: {
        cerfa14023: {
          pieceComplementaire: 18,
          planSituation: 1,
          planLocalisation: 3,
          photos: 5,
          coupesLongitudinales: 6,
          planOuvrage: 8,
          coupesTechniques: 9,
          planFranchissement: 10,
          planImplantation: 11,
        },
        cerfa14024: {
          pieceComplementaire: 18,
          notice: 16,
          planSituation: 1,
          planTravaux: 13,
          schemaSignalisation: 14,
          itineraireDeviation: 15,
        },
      },
    },
    pages: ["demandeurInfo", "request", "cerfa", "pieces", "attestation"],
  }),
  components: {
    localisation: Localisation,
    demandeur: Demandeur,
    "info-demande": InfoDemande,
    "choix-cerfa": ChoixCerfa,
    attestation: Attestation,
    pieces: PiecesJointes,
    VStepper,
  },
  watch: {
    step: {
      deep: true,
      handler: function (val, oldVal) {
        if (val === 1) {
          //TODO: degeu à changer
          setTimeout(function () {
            window.Event.$emit("refreshMap");
          }, 1);
        }
      },
    },
  },
  computed: {
    request: {
      get: function () {
        return this.dossierSelected;
      },
      set: function (newValue) {
        this.setDossier(newValue);
      },
    },
    ...Vuex.mapGetters("StepperDemande", ["steps", "step", "stepsMap"]),
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
    ...Vuex.mapGetters("Dossiers", ["dossierSelected"]),
    ...Vuex.mapGetters("Petitioner", ["petitioner", "beneficiary"]),
    ...Vuex.mapGetters("Cerfa", ["cerfa14023", "cerfa14024"]),
    ...Vuex.mapGetters("Document", ["missingDocuments"]),
    stepControl: {
      get() {
        return this.step;
      },
      set(step) {
        this.setStep(step);
      },
    },
  },

  methods: {
    error(message) {
      this.stepperClass = "errorstepper no-padding form-horizontal";
      Vue.prototype.$awn.alert(message);
    },

    ...Vuex.mapActions("StepperDemande", ["setStep"]),
    ...Vuex.mapActions("Dossiers", [
      "addDossier",
      "initDossier",
      "initPoint",
      "getDossier",
      "updateDossier",
      "deleteDossier",
    ]),
    ...Vuex.mapActions("Petitioner", [
      "addPetitionner",
      "updatePetitionner",
      "initPetitioner",
      "setPetitioner",
      "setBeneficiary",
    ]),
    ...Vuex.mapActions("Cerfa", [
      "addCerfa14023",
      "addCerfa14024",
      "initCerfa14024",
      "initCerfa14023",
      "setCerfa14024",
      "setCerfa14023",
      "updateCerfa14023",
      "updateCerfa14024",
    ]),
    ...Vuex.mapActions("Document", ["sendDocument", "getDocuments"]),
    previousStep(stepper) {
      this.stepperClass = "no-padding form-horizontal";
      stepper.previous();
      document.getElementById("container").scrollTo(0, 0);
    },
    nextStep(stepper) {
      if (this.steps === this.stepControl) {
        this.Finish();
      } else {
        stepper.next();
        this.stepperClass = "no-padding form-horizontal";
        document.getElementById("container").scrollTo(0, 0);
      }
    },
    async sendDocuments(request_id, std_user_id) {
      let rep = null;
      for (const [key, value] of Object.entries(this.missingDocuments)) {
        if (!!value.file) {
          value.file.typeDocumentId = value.typeDocument.id;
          value.file.stdUserId = std_user_id;
          value.file.requestId = request_id;
          rep = await this.sendDocument(value.file);
        }
      }
    },
    async Finish(stepper) {
      //traitement
      let rep = null;
      if (this.add == true) {
        this.request.id = await this.addDossier(this.request);
        if (this.request.id != null) {
          this.request.stateId = 1;

          this.request.petitionerId = await this.addPetitionner(
            this.petitioner
          );
          if (this.request.isbeneficiaire) {
            this.request.beneficiaryId = await this.addPetitionner(
              this.beneficiary
            );
          }
          if (this.request.type.includes("cerfa14023")) {
            this.request.cerfa1402301Id = await this.addCerfa14023(
              this.cerfa14023
            );
          }
          if (this.request.type.includes("cerfa14024")) {
            this.request.cerfa1402401Id = await this.addCerfa14024(
              this.cerfa14024
            );
          }
          if (
            this.request.cerfa1402401Id == null &&
            this.request.cerfa1402301Id == null
          ) {
            Vue.prototype.$awn.alert(
              "Une erreur est survenu lors de la création du cerfa !"
            );
            this.deleteDossier(this.request.id);
            return;
          }

          this.sendDocuments(this.request.id, this.userConnected.id);
          rep = await this.updateDossier(this.request);

          //vidage du niveau de dessin et de point
          window.Event.$emit("clearLayer", "RequestPointLayer");
          window.Event.$emit("clearLayer", "drawnFeatures");
          // let encrypted = this.$aes.encrypt(this.request.id.toString());
          router.push({ name: "Dossier", params: { id: this.request.id } });
        }
      } else {
        rep = await this.updatePetitionner(this.petitioner);
        if (this.petitioner.isbeneficiaire) {
          rep = await this.updatePetitionner(this.beneficiary);
        }
        if (this.request.type.includes("cerfa14023")) {
          rep = await this.updateCerfa14023(this.cerfa14023);
        }
        if (this.request.type.includes("cerfa14024")) {
          rep = await this.updateCerfa14024(this.cerfa14024);
        }

        if (this.request.stateId == 8) {
          this.request.missingDocuments = this.missingDocuments;
          this.sendDocuments(this.request.id, this.userConnected.id);
          this.request.stateId = 9;
          this.request.missingDocuments = null;
        } else {
          this.sendDocuments(this.request.id, this.userConnected.id);
        }

        rep = await this.updateDossier(this.request);
        // let encrypted = this.$aes.encrypt(this.request.id.toString());
        router.push({
          name: "Dossier",
          params: { id: this.request.id },
        });
      }
    },
  },
};
</script>

<style scoped>
/* prevent click events on all steppers */
div.v-stepper {
  /* > div.v-stepper-root > div.v-step*/
  pointer-events: none;
}
</style>
